export const iconFontAwesomeMedicalHealthWheelchairMove = (
	<i className="fa-solid fa-wheelchair-move"></i>
);
